import { Model } from "@interfaces/model.interface";
import { Process } from "@interfaces/process.interface";

export interface Operation extends Model {
	actualRunTime?: number;
	actualSetupTime?: number;
	assignedUserProfileId?: number;
	canRunOvernight: boolean;
	dateCompleted?: Date;
	dateStarted?: Date;
	desiredStartTime: string;
	estimatedCycleTime?: number;
	estimatedEndDate?: Date;
	estimatedRemainingRunTime?: number;
	estimatedRunTime?: number;
	estimatedSetupTime?: number;
	estimatedStartDate?: Date;
	isPaused: boolean;
	lastEstimatedAt?: Date;
	machineId?: number;
	notes: string;
	priority: number;
	process?: Process;
	processDescription: string;
	processId?: number;
	programName: string;
	setupEndTime?: Date;
	setupStartTime?: Date;
	stageComplete: boolean;
	stageNumber: number;
	stageStarted: boolean;
	toolOrderId: number;
	toolroomProcessId?: number;
}

export class Operation implements Operation {
	canRunOvernight = false;
	desiredStartTime = "";
	isPaused = false;
	notes = "";
	priority = 0;
	processDescription = "";
	programName = "";
	stageComplete = false;
	stageNumber = 0;
	stageStarted = false;
	toolOrderId = 0;
	constructor(data?: Partial<Operation>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
